import { render, staticRenderFns } from "./WalletTypeCreateModal.vue?vue&type=template&id=512cd7bf"
import script from "./WalletTypeCreateModal.vue?vue&type=script&lang=js"
export * from "./WalletTypeCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports